import { render, staticRenderFns } from "./sojishikz.vue?vue&type=template&id=3b93bbbe&scoped=true&"
import script from "./sojishikz.vue?vue&type=script&lang=js&"
export * from "./sojishikz.vue?vue&type=script&lang=js&"
import style0 from "./sojishikz.vue?vue&type=style&index=0&id=3b93bbbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b93bbbe",
  null
  
)

export default component.exports